export default __webpack_public_path__ + "static/media/citiesIcon.8db7f9c9.svg";